/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportsreason2Inputs */

const en_contentreportsreason2 = /** @type {(inputs: Contentreportsreason2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const de_contentreportsreason2 = /** @type {(inputs: Contentreportsreason2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Contentreportsreason2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportsreason2 = /** @type {((inputs?: Contentreportsreason2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportsreason2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportsreason2(inputs)
	return de_contentreportsreason2(inputs)
});
export { contentreportsreason2 as "contentReportsReason" }